// Constants shared by the client's pages and components. Put a new constant here rather than at the top of the file
// that uses it, unless it is only meaningful inside one component.

// ---------------------------------------------------------------------------------------------------------------
// External pages
// ---------------------------------------------------------------------------------------------------------------

// Scan2Pay's QuickBooks App Store listing, opened to leave a review (rating modal's 5 stars, setup guide's "Amazing!").
export const APP_STORE_REVIEW_URL = "https://quickbooks.intuit.com/app/apps/appdetails/scan2pay/?checkLogin=true";

// Intuit's account security page, where the "Verify email" button is (login page, email_unverified steps).
export const INTUIT_SECURITY_URL = "https://accounts.intuit.com/app/account-manager/security";

// ---------------------------------------------------------------------------------------------------------------
// Messages
// ---------------------------------------------------------------------------------------------------------------

// Shown when the server refuses an action because a failed payment froze the company (403 company_inactive).
export const FROZEN_MESSAGE = "Your subscription is frozen because a payment failed. Update your payment method on the Usage & Plan page.";

// Why emailing a QR invoice failed, by the server's error code (/send_user_qr_invoice_as_email). email_failed means
// QuickBooks or SendGrid failed, and the server has already alerted us.
export const EMAIL_ERROR_MESSAGES = {
    invalid_recipient: "Please enter one valid email address for the recipient.",
    invalid_subject: "Please enter a one-line subject of up to 200 characters.",
    invalid_content: "The message is too long. Please keep it under 5,000 characters.",
    email_failed: "We couldn't send this email right now. Our team has been notified, please try again in a few minutes.",
};

// ---------------------------------------------------------------------------------------------------------------
// Premium features (PremiumFeatureModal: the plans, with a checkout, for a company on the Free plan)
// ---------------------------------------------------------------------------------------------------------------

export const EMAIL_PREMIUM_TITLE = "Sending QR invoices by email is a premium feature";
export const EMAIL_PREMIUM_MESSAGE = "Upgrade to a paid plan to email QR invoices to your customers straight from Scan2Pay. Choose a plan to unlock it:";

// The company has used all of its QR invoices for the period (any plan) and clicked "New QR Invoice". A paying company
// switches its subscription in place, which Paddle prorates; a company that isn't paying buys a new one, so the prorated
// line is only for the paying ones.
export const QUOTA_PREMIUM_TITLE = "You've used all your QR invoices for this month";
export const QUOTA_PREMIUM_MESSAGE_FREE = "Upgrade to a paid plan to keep generating QR invoices. Choose a plan:";
export const QUOTA_PREMIUM_MESSAGE_PAID = "Upgrade your plan to keep generating QR invoices. The upgrade takes effect right away, and you're billed only the prorated difference for the rest of your current billing period.";

// After Paddle reports a payment, how long to wait for its webhook to move the company to the new plan.
export const PLAN_CONFIRM_TIMEOUT_MS = 45000;

// ---------------------------------------------------------------------------------------------------------------
// Crisp
// ---------------------------------------------------------------------------------------------------------------

// How long to wait for Crisp's session before deciding without it (if Crisp never loads, e.g. blocked, the review
// decisions go by has_left_review alone after this long).
export const CRISP_WAIT_MS = 8000;

// ---------------------------------------------------------------------------------------------------------------
// Rating modal ("How are we doing?", ReviewPromptModal)
// ---------------------------------------------------------------------------------------------------------------

// The modal can't be closed for this long after it appears (or until a star is clicked); then the X shows.
export const REVIEW_CLOSE_DELAY_MS = 7000;

// Stars run from 1 to this; the top rating opens the App Store review page.
export const REVIEW_STAR_COUNT = 5;

export const REVIEW_STAR_GOLD = "#f5b301";
export const REVIEW_STAR_EMPTY = "#c3cad3";

// Our reply in the Crisp chat after a 1-4 star rating (displayed to the visitor, not sent).
export const LOW_RATING_REPLY = "Thank you for rating Scan2Pay! What could we do better? Write to us here and we'll take care of it.";

// If Crisp never confirms the visitor's rating message (message:sent), our reply is shown after this long anyway.
export const LOW_RATING_REPLY_FALLBACK_MS = 3000;
